import httpClient from '@/http-client'

import { baseState, baseMutations } from '@/store/mixins'
import { join } from 'lodash'
import moment from 'moment'

export const state = {
  ...baseState,
  loading: false,
  products: [],
  customers: [],
  saleEmployees: [],
  currencies: [],
  paymentMethods: [],
  banks: [],
  quotations: [],
  saleContracts: [],
  location_id: [],
  branch_id: [],
  is_paid: undefined,
  dateRange: [
    moment()
      .add(-7, 'days')
      .format('DD-MM-YYYY'),
    moment().format('DD-MM-YYYY')
  ]
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  PUSH_NEW_CUSTOMER(state, customer) {
    state.customers.push(customer)
  },
  SET_LOADING(state, value) {
    state.loading = value
  },
  SET_DATE_RANGE(state, date) {
    state.dateRange = date
  },
  SET_LOCATION_ID(state, value) {
    state.location_id = value
  },
  SET_IS_PAID(state, data) {
    state.is_paid = data
  },
  SET_BRANCH_ID(state, value) {
    state.branch_id = value
  }
}

export const actions = {
  async fetch(context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        branch_id: context.state.branch_id,
        location_id: context.state.location_id,
        is_paid: context.state.is_paid,
        search: context.state.search,
        date_between: context.state.dateRange
          ? join(context.state.dateRange, ',')
          : undefined
      },
      attrubutes
    )
    const saleInvoiceList = await httpClient.get('/api/v1/sale-invoices', {
      params
    })
    context.commit('RECEIVE_RESOURCES', saleInvoiceList.data)
    return saleInvoiceList
  },
  async onGetCustomer(context, { params } = {}) {
    context.state.loading = true
    const customer = await httpClient.get('/api/v1/sale-invoices/customers', {
      params
    })
    context.state.customers = customer.data.data
    context.state.loading = false
    return customer.data.data
  },
  async onGetSale(context, search_sale) {
    context.state.loading = true
    const sale = await httpClient.get('/api/v1/sale-invoices/sales', {
      params: {
        search_sale
      }
    })
    context.state.saleEmployees = sale.data.data
    context.state.loading = false
  },
  async onGetCurrency(context) {
    context.state.loading = true
    const currency = await httpClient.get('/api/v1/sale-invoices/currencies')
    context.state.currencies = currency.data.data
    context.state.loading = false
    return currency.data
  },
  async onGetProduct(context, { params }) {
    const products = await httpClient.get('/api/v1/sale-invoices/products', {
      params
    })
    return products.data
  },
  async onGetPaymentMethod(context) {
    context.state.loading = true
    const paymentMethod = await httpClient.get(
      '/api/v1/sale-invoices/payment-methods'
    )
    context.state.paymentMethods = paymentMethod.data.data
    context.state.loading = false
    return paymentMethod.data
  },
  async onGetBank(context) {
    if (context.state.banks.length === 0) {
      context.state.loading = true
      const banks = await httpClient.get('/api/v1/sale-invoices/banks')
      context.state.banks = banks.data.data
      context.state.loading = false
      return banks.data
    }
  },
  async onGetQuotation(context, { params }) {
    context.state.loading = true
    const quotations = await httpClient.get(
      '/api/v1/sale-invoices/quotations',
      { params }
    )
    context.state.quotations = quotations.data.data
    context.state.loading = false
    return quotations.data
  },
  async onGetSaleContract(context, { params }) {
    context.state.loading = true
    const saleContracts = await httpClient.get(
      '/api/v1/sale-invoices/sale-contracts',
      { params }
    )
    context.state.saleContracts = saleContracts.data.data
    context.state.loading = false
    return saleContracts.data
  },
  async onGetDetailById(context, id) {
    const quotationDetail = await httpClient.get(
      `/api/v1/sale-invoices/quotations/${id}`
    )
    return quotationDetail.data
  },
  async onGetSaleDetailById(context, id) {
    const saleContractDetail = await httpClient.get(
      `/api/v1/sale-invoices/sale-contracts/${id}`
    )
    return saleContractDetail.data
  },
  onStore(context, data) {
    return httpClient.post('/api/v1/sale-invoices', data)
  },
  onShow(context, id) {
    return httpClient.get(`/api/v1/sale-invoices/${id}`)
  },
  onDestroy(context, { id, data }) {
    return httpClient.put(`/api/v1/sale-invoices/${id}/delete`, data)
  },
  onPreviewPdf(context, { id, paperSize }) {
    return httpClient.get(`/api/v1/sale-invoices/${id}/pdf`, {
      params: { paperSize }
    })
  },
  onUpdateSaleCustomer(context, data) {
    return httpClient.put('/api/v1/sale-invoices/edit-sale-customers', data)
  },
  async exportExcel(context, attrubutes = {}) {
    let params = Object.assign(
      {
        branch_id: context.state.branch_id,
        location_id: context.state.location_id,
        is_paid: context.state.is_paid,
        search: context.state.search,
        date_between: context.state.dateRange
          ? join(context.state.dateRange, ',')
          : undefined
      },
      attrubutes
    )
    return httpClient.post('/api/v1/sale-invoices/export-excels', params, {
      responseType: 'arraybuffer'
    })
  },
  onSearchSerial(context, params) {
    return httpClient.get(`/api/v1/sale-invoices/serials`, { params })
  },
  onFindSerial(context, serial) {
    return httpClient.get(`/api/v1/sale-invoices/find-serials/${serial}`,)
  },
}
